import { forwardRef, useImperativeHandle } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { EmployeeBlocksEmployeeFragment } from 'generated/resources/graphql'

import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import asyncAction from 'modules/core/lib/asyncAction'

import { useCodeableForm } from 'modules/payroll_integrations/components/Form/hooks'

interface Props {
  integration: string
  label: string
  employee: EmployeeBlocksEmployeeFragment
  readonly?: boolean
  onChange: () => void
}

export interface CodeHandle {
  onSubmit: () => Promise<void>
  isDirty: () => boolean
}

const Code = forwardRef<CodeHandle, Props>(function Code(
  { integration, label, employee, readonly, onChange },
  ref
) {
  const form = useCodeableForm(employee, 'Employee', label, integration)
  useImperativeHandle(ref, () => ({
    onSubmit: async () => {
      if (form.isDirty) {
        const result = await asyncAction(() => form.submit())

        if (!result.success) return

        form.cleanAll()

        onChange()
      }
    },
    isDirty: () => {
      return form.isDirty
    },
  }))

  return (
    <Box paddingBottom="s16">
      <FormRow>
        <Text
          readonly={readonly}
          label={form.get('codeable_label').value}
          field={form.get('code')}
          type="text"
          onChange={onChange}
        />
      </FormRow>
    </Box>
  )
})

export default Code
